import moment from "services/locale/momentInit.js";

export const getLocalDateMoment = (date, timezone) => {
  const localDate = new moment(date);
  return timezone ? (new moment.utc(localDate).tz(timezone)) : localDate;
}

export const formatMstoMS = (ms) => {
  const minute = Math.floor(ms / 60000);
  const second = Math.floor(ms / 1000) % 60;
  return String(minute).padStart(2, '0') + ":" + String(second).padStart(2, '0');
};

export const formatMstoHMS = (ms) => {
  const hour = Math.floor(ms / 3600000);
  const minute = Math.floor(ms / 60000) % 60;
  const second = Math.floor(ms / 1000) % 60;
  return String(hour).padStart(2, '0') + ":" + String(minute).padStart(2, '0') + ":" + String(second).padStart(2, '0');
};

export const formatMstoDHMS = (ms) => {
  const day = Math.floor(ms / 86400000);
  const hour = Math.floor(ms / 3600000) % 24;
  const minute = Math.floor(ms / 60000) % 60;
  const second = Math.floor(ms / 1000) % 60;
  return String(day) + ":" + String(hour).padStart(2, '0') + ":" + String(minute).padStart(2, '0') + ":" + String(second).padStart(2, '0');
};

export const parseHHmmTime = (time) => {
  const timeSplit = time.split(":");
  timeSplit[0] = isNaN(timeSplit[0]) ? 0 : Number(timeSplit[0]);
  timeSplit[1] = isNaN(timeSplit[1]) ? 0 : Number(timeSplit[1]);
  return {
    hours: timeSplit[0],
    minutes: timeSplit[1],
  }
}